const misc = {
  buttonHeight: '40px',
  borderRadius: '6px',
};

export default misc;
